/**
 * Andre Garen - alttan acilan bilgi sayfalari (Tur 23 EK9 \u00a74.5): teslimat paneli (D067) ve magaza karti (D014/D018).
 * Isaretler: snippets/ag-teslimat-paneli.liquid, snippets/ag-magaza-karti.liquid (sayfada tek kopya).
 * Acan: [data-ag-teslimat-ac] / [data-ag-magaza-ac] (urun seridi, bant mesajlari). Baslik ve saat satiri AGZaman'dan;
 * acikken dakikada bir tazelenir. Kapanir: Esc, perde, kapat dugmesi; odak acan ogeye doner (Safari dokunulan dugmeye
 * odak vermez - acan oge kaydedilir).
 */
(function () {
  'use strict';
  /* S053: "Kargoya son" saniyeli sayac (pencere acikken saniyede bir; sayac yoksa "En gec <gun> kargoda") */
  function saniye(kp) {
    var Z = window.AGZaman, et = kp.querySelector('[data-ag-kp-et]'), sy = kp.querySelector('[data-ag-kp-sayac]'); if (!Z || !et || !sy) return;
    var d = Z.simdi(), k = Z.kargo(d), p2 = function (n) { return (n < 10 ? '0' : '') + n; };
    if (k.durum === 'SAYAC') {
      var kalan = Math.max(0, k.kesimDk * 60 - (d.getUTCHours() * 3600 + d.getUTCMinutes() * 60 + d.getUTCSeconds()));
      et.textContent = 'Ayn\u0131 g\u00fcn kargo i\u00e7in'; sy.textContent = (kalan >= 3600 ? Math.floor(kalan / 3600) + ' sa ' : '') + Math.floor(kalan % 3600 / 60) + ' dk'; /* form kural 2: saniye yok */
    } else {
      var eg = Z.enGec ? Z.enGec(d) : null; et.textContent = 'En ge\u00e7'; sy.textContent = eg ? eg.gunAdi + ' kargoda' : '';
    }
  }
  var saniyeZ = null;
  function cumle(s) { s = s.toLocaleLowerCase('tr'); return s.charAt(0).toLocaleUpperCase('tr') + s.slice(1); }
  function odakla(el) { if (!el) return; try { el.focus({ preventScroll: true }); } catch (e) { el.focus(); } }

  var SAYFALAR = [
    { ac: '[data-ag-teslimat-ac]', kap: '[data-ag-teslimat]', kapat: '[data-ag-teslimat-kapat]', tazele: function (kap, t) {
      var Z = window.AGZaman, b = kap.querySelector('[data-ag-teslimat-baslik]'); if (!Z || !b) return;
      var k = Z.kargo(t);
      var m = k.durum === 'SAYAC' ? cumle(Z.sayacMetni + ' ' + k.sayac) : k.durum === 'SONRA' ? 'En ge\u00e7 1 i\u015f g\u00fcn\u00fc i\u00e7inde kargoda' : 'Teslimat ve iade';
      if (b.textContent !== m) b.textContent = m;
      /* Tur 23 EK10 S053 Korfez penceresi (PLAN-UYUM mockup): buyuk saat + tarih, gravur ustunde yay ve gunes (gece ay), dogus/batis,
         "Kargoya son" saniyeli sayac + kesim saati; pencere gorunurken baslik "Korfez penceresi" */
      var kp = kap.querySelector('[data-ag-kp]');
      if (kp && Z.gunes) {
        var d = t || Z.simdi(), su = d.getUTCHours() * 60 + d.getUTCMinutes(), g = Z.gunes(d), gun = su >= g.dogusDk && su < g.batisDk;
        var p2 = function (n) { return (n < 10 ? '0' : '') + n; };
        if (kp.getClientRects().length && b.textContent !== 'K\u00f6rfez penceresi') b.textContent = 'K\u00f6rfez penceresi';
        kp.querySelector('[data-ag-kp-saat]').textContent = p2(d.getUTCHours()) + ':' + p2(d.getUTCMinutes());
        var AY = ['Ocak', '\u015eubat', 'Mart', 'Nisan', 'May\u0131s', 'Haziran', 'Temmuz', 'A\u011fustos', 'Eyl\u00fcl', 'Ekim', 'Kas\u0131m', 'Aral\u0131k'];
        var GN = ['Pazar', 'Pazartesi', 'Sal\u0131', '\u00c7ar\u015famba', 'Per\u015fembe', 'Cuma', 'Cumartesi'];
        kp.querySelector('[data-ag-kp-tarih]').textContent = '\u0130zmir \u00b7 ' + GN[d.getUTCDay()] + ', ' + d.getUTCDate() + ' ' + AY[d.getUTCMonth()];
        var f = gun ? (su - g.dogusDk) / (g.batisDk - g.dogusDk) : ((su - g.batisDk + 1440) % 1440) / (1440 - (g.batisDk - g.dogusDk));
        f = Math.max(0, Math.min(1, f));
        var c = kp.querySelector('[data-ag-kp-gunes]'), u = 1 - f;
        c.style.left = ((u * u * 10 + 2 * u * f * 150 + f * f * 290) / 3).toFixed(2) + '%';
        c.style.top = ((u * u * 100 + 2 * u * f * -10 + f * f * 100) / 112 * 70).toFixed(2) + '%';
        kp.setAttribute('data-gun', gun ? '1' : '0');
        kp.querySelector('[data-ag-kp-dogus]').textContent = 'G\u00fcn do\u011fumu ' + g.dogus;
        kp.querySelector('[data-ag-kp-batis]').textContent = 'G\u00fcn bat\u0131m\u0131 ' + g.batis;
        var kesim = kp.querySelector('[data-ag-kp-kesim]'), ks = k.kesimDk > 0 ? k.kesimDk : 990;
        kesim.innerHTML = ''; kesim.appendChild(document.createTextNode('Kesim saati ' + p2(Math.floor(ks / 60)) + ':' + p2(ks % 60)));
        kesim.appendChild(document.createElement('br')); kesim.appendChild(document.createTextNode('Pazartesi\u2013Cuma'));
        kp._k = k; saniye(kp);
      }
    } },
    { ac: '[data-ag-magaza-ac]', kap: '[data-ag-magaza]', kapat: '[data-ag-magaza-kapat]', tazele: function (kap, t) {
      var Z = window.AGZaman, s = kap.querySelector('[data-ag-magaza-saat]'); if (!Z || !s) return;
      if (!s._ilk) s._ilk = s.textContent;
      var m = Z.magaza(t);
      var yeni = m.acik ? 'Bug\u00fcn ' + m.kapanis + "'" + Z.ek(m.kapanis) + ' kadar a\u00e7\u0131k' : s._ilk;
      if (s.textContent !== yeni) s.textContent = yeni;
    } }
    , { ac: '[data-ag-ucsoru-ac]', kap: '[data-ag-ucsoru]', kapat: '[data-ag-ucsoru-kapat]', tazele: function (kap, t, el) {
      /* Tur 23 EK10 S034 uc soru: acan dugmenin bolumu gorunur, baslik bolumden */
      if (!el) return;
      var hedef = el.getAttribute('data-ag-ucsoru-ac');
      [].forEach.call(kap.querySelectorAll('[data-ag-ucsoru-bolum]'), function (b) {
        var bu = b.getAttribute('data-ag-ucsoru-bolum') === hedef; b.hidden = !bu;
        if (bu) kap.querySelector('[data-ag-ucsoru-baslik]').textContent = b.getAttribute('data-baslik');
      });
    } }
  ].filter(function (p) { p.el = document.querySelector(p.kap); return !!p.el; });
  if (!SAYFALAR.length) return;

  var acik = null, tetik = null;
  /* Tur 23 EK10 S053: Korfez penceresi asagi kaydirinca kapanir (icerik en ustteyken) */
  SAYFALAR.forEach(function (p) {
    var pn = p.el.querySelector('.ag-filter__panel'), y0 = null;
    if (!pn || !p.el.querySelector('[data-ag-kp]')) return;
    pn.addEventListener('touchstart', function (e) { y0 = pn.scrollTop <= 0 && e.touches.length === 1 ? e.touches[0].clientY : null; }, { passive: true });
    pn.addEventListener('touchmove', function (e) {
      if (y0 == null || acik !== p) return;
      var kp = p.el.querySelector('[data-ag-kp]'); if (!kp || !kp.getClientRects().length) return;
      if (e.touches[0].clientY - y0 > 80) { y0 = null; kapa(); }
    }, { passive: true });
  });
  /* iOS WebKit perdeye dokunuste click uretmez (Test Odasi H016): perde touchend'de kapatir */
  SAYFALAR.forEach(function (p) {
    var perde = p.el.querySelector('.ag-filter__scrim');
    if (perde) perde.addEventListener('touchend', function (e) { if (acik === p) { if (e.cancelable) e.preventDefault(); kapa(); } });
  });
  function ac(p, el) {
    if (acik) kapa(true);
    tetik = el || document.activeElement; acik = p;
    p.tazele(p.el, undefined, el);
    p.el.hidden = false; p.el.setAttribute('data-open', '1');
    var kp0 = p.el.querySelector('[data-ag-kp]'); if (kp0 && kp0.getClientRects().length) { clearInterval(saniyeZ); saniyeZ = setInterval(function () { saniye(kp0); }, 1000); p.tazele(p.el, undefined, el); }
    document.body.style.overflow = 'hidden';
    setTimeout(function () { odakla(p.el.querySelector('.ag-icon-btn' + p.kapat)); }, 30);
  }
  function kapa(sessiz) {
    if (!acik) return;
    clearInterval(saniyeZ); saniyeZ = null;
    acik.el.removeAttribute('data-open'); acik.el.hidden = true; acik = null;
    document.body.style.overflow = '';
    var t = tetik; tetik = null;
    if (t && !sessiz) setTimeout(function () { odakla(t); }, 0);
  }
  document.addEventListener('click', function (e) {
    for (var i = 0; i < SAYFALAR.length; i++) {
      var a = e.target.closest(SAYFALAR[i].ac);
      if (a) { e.preventDefault(); ac(SAYFALAR[i], a); return; }
    }
    if (acik && e.target.closest(acik.kapat)) { e.preventDefault(); kapa(); }
  });
  document.addEventListener('keydown', function (e) {
    if (!acik) return;
    if (e.key === 'Escape') { kapa(); return; }
    if (e.key !== 'Tab') return;
    var panel = acik.el.querySelector('[role="dialog"]'); if (!panel) return;
    var f = [].filter.call(panel.querySelectorAll('a[href], button'), function (x) { return x.getClientRects().length; });
    if (!f.length) return;
    var ilk = f[0], son = f[f.length - 1];
    if (e.shiftKey && document.activeElement === ilk) { e.preventDefault(); odakla(son); }
    else if (!e.shiftKey && document.activeElement === son) { e.preventDefault(); odakla(ilk); }
  });
  if (window.AGZaman) window.AGZaman.her(function (t) { if (acik) acik.tazele(acik.el, t); });
  window.AGTeslimat = { ac: function (el) { ac(SAYFALAR[0], el); }, kapa: kapa };
})();
